import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React from 'react';

interface ThreeDotMenuProps {
  items: string[];
  onAction: (action: string) => void;
  align?: 'horizontal' | 'vertical';
  value?: any;
  field?: { fieldName: string; ValueCheck: { value: string; actionCheck: any } };
  hideAction?: {
    actionName: {
      fieldName: string;
      values: string[];
      hideAction: string[];
    }[];
  };
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({ items, onAction, align = 'vertical', field, value, hideAction }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action: string) => {
    onAction(action);
    handleClose();
  };

  /**
   * Checks if a menu action should be hidden based on `hideAction` rules
   */
  const checkFields = (actionItem: string): boolean => {
    if (!hideAction || !value || !field) return false;

    return hideAction.actionName.some((item) => {
      const hideActionsArray = item.hideAction.flatMap((action) => action.split(',')); // Convert "Change Status,Edit" -> ["Change Status", "Edit"]
      return (
        item.fieldName === field.fieldName &&
        item.values.includes(value) &&
        hideActionsArray.includes(actionItem.trim()) // Trim spaces
      );
    });
  };


  return (
    <>
      <IconButton onClick={handleClick} className={`icon-button-${align}`}>
        {align === 'horizontal' ? <MoreHorizIcon /> : <MoreVertIcon />}
      </IconButton>
      <Menu
        style={{ marginLeft: 22 }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items
          .filter((item) => !checkFields(item)) // Remove hidden actions before mapping
          .map((item) => (

            item && <MenuItem
              key={item}
              onClick={() => handleMenuItemClick(item)}
              sx={{ height: 30, fontSize: '0.875rem' }}
            >
              {item}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default ThreeDotMenu;
